import { AccessTime, CancelOutlined, CheckCircleOutline, ErrorOutline, HourglassEmptyOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'
import { TaskStatusEnum } from '@omnea-app/requests/requestsFrontendClient'

interface Props {
  status: TaskStatusEnum
}

export const TaskStatusChip = ({ status }: Props) => {
  const { t } = useTranslation('tasks')

  switch (status) {
    case TaskStatusEnum.NOT_STARTED:
      return <DefaultChip label={t('table.not-started')} color="warning" icon={<HourglassEmptyOutlined />} />
    case TaskStatusEnum.IN_PROGRESS:
      return <DefaultChip label={t('table.in-progress')} color="primary" icon={<AccessTime />} />
    case TaskStatusEnum.REJECTED:
      return <DefaultChip label={t('table.rejected')} color="error" icon={<CancelOutlined />} />
    case TaskStatusEnum.COMPLETE:
      return <DefaultChip label={t('table.completed')} color="success" icon={<CheckCircleOutline />} />
    case TaskStatusEnum.OVERDUE:
      return <DefaultChip label={t('table.overdue')} color="error" icon={<ErrorOutline />} />
    case TaskStatusEnum.AMENDMENT_REQUESTED:
      return <DefaultChip label={t('table.awaiting-amendment')} color="neutral" icon={<ErrorOutline />} />
    case TaskStatusEnum.AMENDMENT_REQUIRED:
      return <DefaultChip label={t('table.amendment-required')} color="neutral" icon={<ErrorOutline />} />
  }
}
